import classNames from 'classnames'
import { useState } from 'react'
import { WebQuote } from '../../../../server/utils/web/buildWebOffer'
import sortWebQuotes from '../../../../server/utils/web/sortWebProducts'
import { WebHeader } from '../navigation/WebHeader'
import styles from './WebStep01IndexPage.module.css'
import { WebStep01IndexGreySection } from './sections/grey/WebStep01IndexGreySection'
import { WebStep01IndexPinkSection } from './sections/pink/WebStep01IndexPinkSection'

type Props = {
  onNextButtonClick: () => void
  quotes: WebQuote[]
}

export function WebStep01IndexPage(props: Props) {
  const [selectedIndex, setSelectedIndex] = useState<number>()

  const sortedQuotes = sortWebQuotes(props.quotes)

  const showDetailProduct = (index: number) => {
    if (selectedIndex !== index) {
      setSelectedIndex(index)
    } else {
      setSelectedIndex(undefined)
    }
  }

  return (
    <div>
      <WebHeader variant="home" />
      <div className="-mx-5">
        <div className={classNames('text-sm md:text-xl', 'flex flex-col items-center', 'mb-0 sm:mb-10 md:mb-0')}>
          <div
            className={classNames(
              styles.bgHeader,
              // Longer background when a product is open
              { [`${styles.bgHeaderOpen}`]: selectedIndex !== undefined }
            )}
          />
          <div className="w-full flex flex-col items-center">
            <WebStep01IndexPinkSection
              onNextButtonClick={props.onNextButtonClick}
              quotes={sortedQuotes}
              selectedIndex={selectedIndex}
              showDetailProduct={showDetailProduct}
            />
          </div>
          {/* </div> */}
        </div>

        <div className="flex flex-col items-center min-h-max">
          {/* <div className="max-w-7xl w-full"> # removed max-w-7xl to make it full width*/}
          <div className="w-full">
            <WebStep01IndexGreySection />
          </div>
        </div>
      </div>
    </div>
  )
}

export const maxW = 'sm:px-8 w-full max-w-[315px] sm:max-w-[900px] md:max-w-[1150px]'
